import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    '10': '10',
    '25': '25',
    '50': '50',
    '100': '100',
    $vuetify: {
      open: 'open',
      close: 'close',
      noDataText: 'No record found',
      // TECH-2672 — accepting a personal investor invitation on this company's own domain, and the
      // state right after it (the company has not released any module yet).
      investorInvite: {
        title: 'Invitation from {0}',
        accept: 'Accept invitation',
        personal: {
          description: 'Accept this invitation to follow {0}. We will create your own personal account.',
          nameLabel: 'Your name',
          reuseAccount: 'This invitation will be added to the personal account you already have.',
          modulesNotice: 'The company releases the Dataroom after you accept, so it may still be unavailable at first.',
        },
        form: {
          email: 'Email',
          password: 'Password',
          passwordConfirmation: 'Confirm password',
          haveAccount: 'I already have an account',
          needAccount: 'I need to create an account',
          verifyEmail: 'Check your inbox to confirm your e-mail, then open this link again to finish.',
        },
        errors: {
          not_found: 'This invitation link is invalid.',
          expired: 'This invitation has expired.',
          revoked: 'This invitation was revoked.',
          already_accepted: 'This invitation was already accepted.',
          acceptFailed: 'Failed to accept the invitation. Please try again.',
          signInFailed: 'Invalid e-mail or password.',
          signUpFailed: 'Could not create the account. Please try again.',
          emailAlreadyRegistered: 'This e-mail already has an account — sign in instead.',
        },
      },
      accessPending: {
        title: 'Access not released yet',
        text: 'Your invitation was accepted, but the company has not released the Dataroom for you yet. You will be able to open it here as soon as they do.',
        openCockpit: 'Open Cockpit',
        signOut: 'Sign out',
      },
      layout: {
        menu: {
          dashboard: {
            title: 'Home',
          },
          myCompanies: {
            title: 'Companies',
          },
          cockpit: {
            title: 'Cockpit',
          },
          configuration: {
            title: 'Configuration',
          },
          'company-area': {
            title: 'Company Area',
          },
          profile: {
            title: 'Profile',
          },
          logout: {
            title: 'Go Back',
          },
        },
      },
      home: {
        tabs: {
          home: {
            title: 'Home',
            socials: 'Social Media',
          },
          team: {
            title: 'Team',
          },
          captable: {
            title: 'Captable',
          },
          'business-plan-pitch-deck': {
            title: 'Business Plan & Pitch Deck',
          },
          'linkedin-feed': {
            title: 'LinkedIn Feed',
          },
          documents: {
            title: 'Documents',
          },
        },
      },
      'dashboard-dataroom': {
        title: 'Dashboard',
        socials: 'Social Media',
        home: {
          title: 'Home',
        },
        team: {
          title: 'Team',
          'show-more': 'Show more',
          'show-less': 'Show less',
        },
        captable: {
          title: 'Captable',
        },
        documents: {
          title: 'Documents',
        },
        'linkedin-feed': {
          title: 'LinkedIn Feed',
        },
        video: {
          unavailable: 'This video is unavailable right now',
        },
      },
      'my-companies': {
        home: {
          title: {
            text: 'Companies',
          },
          'card-header': {
            'search-input': {
              placeholder: 'Search by Name or Tax Id...',
            },
            'filter-companies-btn': {
              text: 'Filter Companies',
            },
            'generate-cockpit-btn': {
              text: 'Generate Cockpit',
            },
          },
          table: {
            column: {
              name: {
                text: 'Name',
              },
              'tax-id': {
                text: 'Tax ID',
              },
              segment: {
                text: 'Segment',
              },
              group: {
                text: 'Group',
              },
              organization: {
                text: 'Organization',
              },
              'last-alerts': {
                text: 'Last alerts',
              },
              'updated-at': {
                text: 'Updated at',
              },
              actions: {
                text: 'Actions',
              },
            },
          },
        },
      },
      cockpit: {
        tabs: {
          summary: {
            title: 'Summary',
          },
          analysis: {
            title: 'Analysis',
            cards: {
              accounting: {
                title: 'Accounting',
                description: 'Analyze the Balance Sheet, P&L and other financial statements of the company',
              },
              financial: {
                title: 'Financial',
                description: 'Analyze Cash Flow, Financial P&L, Burn Rate, Runway and other financial metrics',
              },
              comercial: {
                title: 'Comercial',
                description:
                  "Check out the company's commercial metrics. Pipeline, Conversion rate, Churn Rate and other metrics",
              },
              operation: {
                title: 'Complementary Data',
                description: 'Add and monitor supplementary data from your company',
              },
            },
          },
          alerts: {
            title: 'Alerts',
          },
        },
        financial: {
          title: {
            text: 'Financial Analysis',
          },
          tabs: {
            cashflow: {
              title: 'Cash Flow',
            },
            'income-statement': {
              title: 'Cash Flow',
            },
            'other-indicators': {
              title: 'Other Indicators',
            },
            'expected-realized': {
              title: 'Budget vs Actual',
            },
            summary: {
              title: 'Summary',
            },
            receipts: {
              title: 'Receipts',
            },
            payments: {
              title: 'Payments',
            },
            budget: {
              title: 'Budget',
            },
            'burn-rate': {
              title: 'Burn Rate',
            },
            runaway: {
              title: 'Runaway',
            },
            'cash-flow-table': {
              title: 'Cash-Flow Table',
              actions: {
                'from-to': {
                  text: 'From-To',
                },
                'x-ray': {
                  text: 'X-Ray',
                  tabs: {
                    table: {
                      title: 'Table',
                    },
                    dashboard: {
                      title: 'Dashboard',
                    },
                  },
                },
              },
              'cash-flow-tables': {
                title: {
                  operations: 'Cash Flow from Operations',
                  financing: 'Cash Flow from Financing',
                  investment: 'Cash Flow from Investment',
                  total: 'Total Cash Flow Summary',
                  summary: 'Summary',
                  resume: 'Summary',
                },
                rows: {
                  'cash-in': 'Cash in',
                  'cash-out': 'Cash out',
                  result: 'Result',
                  'total-cash-flow': 'Total Cash Flow',
                  'beginning-of-period': 'Beginning of Period',
                  'end-of-period': 'End of Period',
                },
              },
              'from-to-table': {
                titles: {
                  operations: 'Operations',
                  financing: 'Financing',
                  investment: 'Investment',
                  total: 'Total',
                  'operations-cash-in': 'Operations Cash In',
                  'operations-cash-out': 'Operations Cash Out',
                  'operations-result': 'Operations Result',
                  'financing-cash-in': 'Financing Cash In',
                  'financing-cash-out': 'Financing Cash In',
                  'financing-result': 'Financing Result',
                  'investment-cash-int': 'Investment Cash In',
                  'investment-cash-out': 'Investment Cash Out',
                  'investment-result': 'Investment Result',
                  'total-cash-flow': 'Total Cash Flow',
                },
                cols: {
                  'category-identifier': 'Account Number',
                  account: 'Account',
                  'client-account': 'Client Account',
                  type: 'Type',
                  value: 'Value',
                },
                rows: {
                  total: 'Total',
                },
              },
            },
          },
        },
        indicators: {
          title: {
            text: 'Complementary Data',
          },
          tabs: {
            kpi: {
              title: 'KPI X-Ray',
              'not-found-message': 'KPIs not found, please contact the company',
              header: {
                'create-btn': {
                  text: 'Create Indicator for reference month',
                },
              },
              actions: {
                'x-ray': {
                  text: 'X-Ray',
                },
                edit: {
                  text: 'Edit',
                },
                delete: {
                  text: 'Delete',
                },
              },
              'edit-form': {
                title: {
                  text: 'Update Indicator for reference month',
                },
              },
              form: {
                title: {
                  text: 'Create Indicator',
                },
                fields: {
                  'reference-date': {
                    placeholder: 'Referente Month',
                  },
                  indicator: {
                    placeholder: 'Indicator',
                  },
                },
                save: {
                  text: 'Save',
                },
                cancel: {
                  text: 'Cancel',
                },
              },
            },
            'kpi-table': {
              title: 'Inserted Data',
            },
          },
        },
        accounting: {
          title: {
            text: 'Accounting Analysis',
          },
        },
      },
      'company-area': {
        title: 'Company Area',
        tabs: {
          summary: {
            title: 'Operations',
          },
          client: {
            title: 'Sales',
          },
          analysis: {
            title: 'Analysis',
          },
        },
      },
      auth: {
        'sign-in': {
          needsEmailVerification: {
            text: 'You need to verify your email',
          },
          email: {
            label: 'Email',
          },
          password: {
            label: 'Password',
          },
          'login-btn': {
            text: 'Login',
          },
          'forgot-password-btn': {
            text: 'Forgot Password',
          },
          'first-access-btn': {
            text: 'First Access',
          },
          'remember-me-checkbox': {
            text: 'Remember Me',
          },
          'wrong-credentials': {
            text: 'Invalid email or password',
          },
          'continue-btn': {
            text: 'Continue',
          },
          'no-access': {
            text: 'You do not have access to this platform. Contact the administrator.',
          },
        },
        'sign-up': {
          needsEmailVerification: {
            text: 'You need to verify your email',
          },
          'sign-up-btn': {
            text: 'Sign Up',
          },
          'first-name': {
            label: 'First Name',
          },
          'last-name': {
            label: 'Last Name',
          },
          'confirm-password': {
            label: 'Confirm Password',
          },
          password: {
            label: 'Password',
          },
          'password-mismatch-alert': {
            text: 'Password does not match',
          },
          'email-already-registered': {
            text: 'Email already registered',
          },
          'email-already-registered-prefix': {
            text: 'If you already have an account, please sign in',
          },
          'not-invited': {
            text: 'This email is not registered or invited to access this platform. Contact the administrator.',
          },
        },
        'change-password': {
          message: {
            title: 'Reset Password',
            text: 'Choose your new password',
          },
          password: {
            label: 'Password',
          },
          confirmPassword: {
            label: 'Confirm Password',
          },
          'password-mismatch-alert': {
            text: 'Password does not match',
          },
          'confirm-btn': {
            text: 'Confirm',
          },
        },
        'forgot-password': {
          message: {
            title: 'Forgot your password?',
            text: 'Fill your email and we will send a link to reset your password',
          },
          email: {
            label: 'Email',
          },
          'email-sent-alert': {
            text: 'Sent a link to reset your password',
          },
          'send-link-btn': {
            text: 'Send Link',
          },
          'sign-in-btn': {
            text: 'Sign In',
          },
        },
        'first-access': {
          message: {
            title: 'First Access?',
            text: 'Fill your email and we will send a link to define your password',
          },
          email: {
            label: 'Email',
          },
          'email-sent-alert': {
            text: 'Sent a link to define your password',
          },
          'send-link-btn': {
            text: 'Send Link',
          },
          'sign-in-btn': {
            text: 'Sign In',
          },
        },
      },
      configuration: {
        title: 'Configuration',
        tabs: {
          modules: {
            title: 'Modules',
            cards: {
              accounting: {
                title: 'Accounting',
                description: 'Analyze the Balance Sheet, P&L and other financial statements of the company',
              },
              financial: {
                title: 'Financial',
                description: 'Analyze Cash Flow, Financial P&L, Burn Rate, Runway and other financial metrics',
              },
              comercial: {
                title: 'Comercial',
                description:
                  "Check out the company's commercial metrics. Pipeline, Conversion rate, Churn Rate and other metrics",
              },
              indicators: {
                title: 'Complementary Data',
                description: 'Add and monitor supplementary data from your company',
              },
            },
          },
          alerts: {
            title: 'Alerts',
          },
          users: {
            title: 'Users',
          },
        },
        indicators: {
          tabs: {
            'kpi-table-configuration': {
              title: 'Tables',
              header: {
                'create-btn': {
                  text: 'New KPI Table',
                },
                'search-input': {
                  placeholder: 'Search by Name...',
                },
              },
              form: {
                'create-title': {
                  text: 'Create KPIs Table',
                },
                'edit-title': {
                  text: 'Edit KPIs Table',
                },
                fields: {
                  name: {
                    placeholder: 'Name',
                    'required-message': 'Name is required',
                  },
                  indicator: {
                    'required-message': 'Type is required',
                    placeholder: 'Indicator',
                  },
                },
                save: {
                  text: 'Save',
                },
                cancel: {
                  text: 'Cancel',
                },
              },
              delete: {
                'confirmation-text': 'Confirm Delete?',
                text: 'Delete',
              },
              table: {
                column: {
                  name: {
                    text: 'Indicator',
                  },
                  format: {
                    text: 'Type',
                  },
                  actions: {
                    text: 'Actions',
                  },
                },
              },
            },
            'kpi-configuration': {
              title: 'Indicators',
              header: {
                'create-btn': {
                  text: 'New Indicator',
                },
                'search-input': {
                  placeholder: 'Search by Name...',
                },
              },
              form: {
                'create-title': {
                  text: 'Create Indicator',
                },
                'edit-title': {
                  text: 'Edit Indicador',
                },
                fields: {
                  name: {
                    placeholder: 'Name',
                    'required-message': 'Name is required',
                  },
                  format: {
                    'required-message': 'Type is required',
                    placeholder: 'Type',
                  },
                },
                save: {
                  text: 'Save',
                },
                cancel: {
                  text: 'Cancel',
                },
              },
              table: {
                column: {
                  name: {
                    text: 'Indicator',
                  },
                  format: {
                    text: 'Type',
                  },
                  actions: {
                    text: 'Actions',
                  },
                },
              },
            },
          },
        },
      },
      dataIterator: {
        rowsPerPageText: 'Items per page:',
        pageText: '{0}-{1} of {2}',
      },
      dataFooter: {
        itemsPerPageText: 'Items per page:',
        pageText: '{0}-{1} of {2}',
        itemsPerPageAll: 'All',
        nextPage: 'Next page',
        prevPage: 'Previous page',
        lastPage: 'Last page',
        firstPage: 'First page',
      },
    },
  },
  pt_BR: {
    '10': '10',
    '25': '25',
    '50': '50',
    '100': '100',
    $vuetify: {
      open: 'abrir',
      close: 'fechar',
      noDataText: 'Nenhum registro encontrado',
      // TECH-2672 — aceite de convite de investidor (conta pessoal) no domínio da própria empresa, e
      // o estado imediatamente depois (a empresa ainda não liberou nenhum módulo).
      investorInvite: {
        title: 'Convite de {0}',
        accept: 'Aceitar convite',
        personal: {
          description: 'Aceite este convite para acompanhar {0}. Vamos criar a sua conta pessoal.',
          nameLabel: 'Seu nome',
          reuseAccount: 'Este convite será adicionado à conta pessoal que você já tem.',
          modulesNotice: 'A empresa libera o Dataroom depois do aceite, então ele pode ficar indisponível no início.',
        },
        form: {
          email: 'E-mail',
          password: 'Senha',
          passwordConfirmation: 'Confirme a senha',
          haveAccount: 'Já tenho uma conta',
          needAccount: 'Preciso criar uma conta',
          verifyEmail: 'Confirme seu e-mail na caixa de entrada e abra este link novamente para concluir.',
        },
        errors: {
          not_found: 'Este link de convite é inválido.',
          expired: 'Este convite expirou.',
          revoked: 'Este convite foi revogado.',
          already_accepted: 'Este convite já foi aceito.',
          acceptFailed: 'Não foi possível aceitar o convite. Tente novamente.',
          signInFailed: 'E-mail ou senha inválidos.',
          signUpFailed: 'Não foi possível criar a conta. Tente novamente.',
          emailAlreadyRegistered: 'Este e-mail já tem conta — entre com ela.',
        },
      },
      accessPending: {
        title: 'Acesso ainda não liberado',
        text: 'Seu convite foi aceito, mas a empresa ainda não liberou o Dataroom para você. Assim que liberar, ele abre aqui.',
        openCockpit: 'Abrir o Cockpit',
        signOut: 'Sair',
      },
      layout: {
        menu: {
          dashboard: {
            title: 'Home',
          },
          myCompanies: {
            title: 'Empresas',
          },
          cockpit: {
            title: 'Cockpit',
          },
          'company-area': {
            title: 'Área da Empresa',
          },
          configuration: {
            title: 'Configuração',
          },
          profile: {
            title: 'Perfil',
          },
          logout: {
            title: 'Voltar',
          },
        },
        home: {
          tabs: {
            home: {
              title: 'Início',
              socials: 'Redes Sociais',
            },
            team: {
              title: 'Equipe',
            },
            captable: {
              title: 'Quadro Societário',
            },
            'business-plan-pitch-deck': {
              title: 'Business Plan & Pitch Deck',
            },
            documents: {
              title: 'Documentos',
            },
            'linkedin-feed': {
              title: 'Feed do LinkedIn',
            },
          },
        },
      },
      'dashboard-dataroom': {
        title: 'Dashboard',
        socials: 'Redes Sociais',
        home: {
          title: 'Início',
        },
        team: {
          title: 'Equipe',
          'show-more': 'Ver mais',
          'show-less': 'Ver menos',
        },
        captable: {
          title: 'Quadro Societário',
        },
        documents: {
          title: 'Documentos',
        },
        'linkedin-feed': {
          title: 'Feed do LinkedIn',
        },
        video: {
          unavailable: 'Este vídeo não está disponível no momento',
        },
      },
      'my-companies': {
        home: {
          title: {
            text: 'Empresas',
          },
          'card-header': {
            'search-input': {
              placeholder: 'Buscar por Nome ou CNPJ...',
            },
            'filter-companies-btn': {
              text: 'Filtrar Empresas',
            },
            'generate-cockpit-btn': {
              text: 'Gerar Cockpit',
            },
          },
          table: {
            column: {
              name: {
                text: 'Nome',
              },
              'tax-id': {
                text: 'CNPJ',
              },
              segment: {
                text: 'Segmento',
              },
              group: {
                text: 'Grupo',
              },
              organization: {
                text: 'Organização',
              },
              'last-alerts': {
                text: 'Últimos alertas',
              },
              'updated-at': {
                text: 'Atualizado em',
              },
              actions: {
                text: 'Ações',
              },
            },
          },
        },
      },
      cockpit: {
        tabs: {
          summary: {
            title: 'Resumo',
          },
          analysis: {
            title: 'Análise',
            cards: {
              accounting: {
                title: 'Contábil',
                description: 'Confira o Balanço Patrimonial, DRE e outras demonstrações contábeis da empresa',
              },
              financial: {
                title: 'Financeiro',
                description:
                  'Faça a análise de Fluxo de Caixa, DRE Gerencial, Burn Rate, Runway e outras métricas financeiras',
              },
              comercial: {
                title: 'Comercial',
                description:
                  'Confira as métricas comerciais da empresa. Pipeline completo, Taxa de conversão, Churn Rate e muito mais',
              },
              operation: {
                title: 'Dados Complementares',
                description: 'Adicione e monitore dados complementares da sua empresa',
              },
            },
          },
          alerts: {
            title: 'Alertas',
          },
        },
        financial: {
          title: {
            text: 'Análise Financeira',
          },
          tabs: {
            cashflow: {
              title: 'Fluxo de Caixa',
            },
            'income-statement': {
              title: 'Fluxo de Caixa',
            },
            'other-indicators': {
              title: 'Outros Indicadores',
            },
            'expected-realized': {
              title: 'Orçado vs Realizado',
            },
            'burn-rate': {
              title: 'Burn Rate',
            },
            summary: {
              title: 'Resumo',
            },
            receipts: {
              title: 'Recebimentos',
            },
            payments: {
              title: 'Pagamentos',
            },
            budget: {
              title: 'Orçamento',
            },
            runaway: {
              title: 'Runaway',
            },
            'cash-flow-table': {
              title: 'Tabela de Fluxo de Caixa',
              actions: {
                'from-to': {
                  text: 'De-Para',
                },
                'x-ray': {
                  text: 'Raio-X',
                  tabs: {
                    table: {
                      title: 'Tabela',
                    },
                    dashboard: {
                      title: 'Gráfico',
                    },
                  },
                },
              },
              'cash-flow-tables': {
                title: {
                  operations: 'Fluxo de Caixa Operacional',
                  financing: 'Fluxo de Caixa de Financiamento',
                  investment: 'Fluxo de Caixa de Investimento',
                  total: 'Fluxo de Caixa Total',
                  summary: 'Resumo',
                  resume: 'Resumo',
                },
                rows: {
                  'cash-in': 'Entradas',
                  'cash-out': 'Saídas',
                  result: 'Resultado',
                  'total-cash-flow': 'Fluxo de Caixa Total',
                  'beginning-of-period': 'Início do Período',
                  'end-of-period': 'Fim do Período',
                },
              },
              'from-to-table': {
                titles: {
                  operations: 'Operações',
                  financing: 'Financiamento',
                  investment: 'Investimento',
                  total: 'Total',
                  'operations-cash-in': 'Entradas Operacionais',
                  'operations-cash-out': 'Saídas Operacionais',
                  'operations-result': 'Resultado Operacional',
                  'financing-cash-in': 'Entradas de Financiamento',
                  'financing-cash-out': 'Saídas de Financiamento',
                  'financing-result': 'Resultado de Financiamento',
                  'investment-cash-int': 'Saídas de Investimento',
                  'investment-cash-out': 'Saídas de Investimento',
                  'investment-result': 'Resultado de Investimento',
                  'total-cash-flow': 'Fluxo de Caixa Total',
                },
                cols: {
                  'category-identifier': 'Número da Conta',
                  account: 'Conta',
                  'client-account': 'Conta do Cliente',
                  type: 'Tipo',
                  value: 'Valor',
                },
                rows: {
                  total: 'Total',
                },
              },
            },
          },
        },
        indicators: {
          title: {
            text: 'Dados Complementares',
          },
          tabs: {
            kpi: {
              title: 'Raio-X do KPI',
              'not-found-message': 'KPIs não encontrados, entre em contato com a empresa',
              header: {
                'create-btn': {
                  text: 'Cadastrar Indicador de um Mês',
                },
              },
              actions: {
                'x-ray': {
                  text: 'Raio-X',
                },
                edit: {
                  text: 'Editar',
                },
                delete: {
                  text: 'Deletar',
                },
              },
              'edit-form': {
                title: {
                  text: 'Atualizar Indicador de um mês',
                },
              },
              form: {
                title: {
                  text: 'Cadastro de indicador',
                },
                fields: {
                  'reference-date': {
                    placeholder: 'Mês de Referência',
                  },
                  indicator: {
                    placeholder: 'Indicador',
                  },
                },
                save: {
                  text: 'Salvar',
                },
                cancel: {
                  text: 'Cancelar',
                },
              },
            },
            'kpi-table': {
              title: 'Dados Inseridos',
            },
          },
        },
        accounting: {
          title: {
            text: 'Análise Contábil',
          },
        },
      },
      'company-area': {
        title: 'Área da Empresa',
        tabs: {
          summary: {
            title: 'Operações',
          },
          client: {
            title: 'Comercial',
          },
          analysis: {
            title: 'Análise',
          },
        },
      },
      auth: {
        'sign-in': {
          needsEmailVerification: {
            text: 'Você precisa verificar o email',
          },
          email: {
            label: 'Email',
          },
          password: {
            label: 'Senha',
          },
          'login-btn': {
            text: 'Entrar',
          },
          'forgot-password-btn': {
            text: 'Esqueci a Senha',
          },
          'first-access-btn': {
            text: 'Primeiro Acesso',
          },
          'remember-me-checkbox': {
            text: 'Lembrar',
          },
          'wrong-credentials': {
            text: 'E-mail ou senha inválidos',
          },
          'continue-btn': {
            text: 'Continuar',
          },
          'no-access': {
            text: 'Você não tem acesso a esta plataforma. Entre em contato com o administrador.',
          },
        },
        'sign-up': {
          needsEmailVerification: {
            text: 'Você precisa verificar seu email',
          },
          'sign-up-btn': {
            text: 'Cadastrar',
          },
          'first-name': {
            label: 'Nome',
          },
          'last-name': {
            label: 'Sobrenome',
          },
          'confirm-password': {
            label: 'Confirmar Senha',
          },
          password: {
            label: 'Senha',
          },
          'password-mismatch-alert': {
            text: 'Senhas não são iguais',
          },
          'email-already-registered': {
            text: 'Email já cadastrado',
          },
          'email-already-registered-prefix': {
            text: 'Se você já tem uma conta, por favor faça login',
          },
          'not-invited': {
            text: 'Este email não está cadastrado nem convidado para acessar esta plataforma. Entre em contato com o administrador.',
          },
        },
        'change-password': {
          message: {
            title: 'Redefenir Senha',
            text: 'Escolha sua nova senha abaixo',
          },
          password: {
            label: 'Senha',
          },
          confirmPassword: {
            label: 'Confirmar Senha',
          },
          'confirm-btn': {
            text: 'Confirmar',
          },
        },
        'forgot-password': {
          message: {
            title: 'Esqueceu sua senha?',
            text: 'Informe seu endereço de email e enviaremos um link para redefinir sua senha',
          },
          email: {
            label: 'Email',
          },
          'email-sent-alert': {
            text: 'Link enviado por e-mail',
          },
          'send-link-btn': {
            text: 'Enviar Link',
          },
          'sign-in-btn': {
            text: 'Fazer Login',
          },
          'password-mismatch-alert': {
            text: 'Senhas não são iguais',
          },
        },
        'first-access': {
          message: {
            title: 'Primeiro Acesso?',
            text: 'Informe seu endereço de email e enviaremos um link para redefinir sua senha',
          },
          email: {
            label: 'Email',
          },
          'email-sent-alert': {
            text: 'Link enviado por e-mail',
          },
          'send-link-btn': {
            text: 'Enviar Link',
          },
          'sign-in-btn': {
            text: 'Fazer Login',
          },
          'password-mismatch-alert': {
            text: 'Senhas não são iguais',
          },
        },
      },
      configuration: {
        title: 'Configuração',
        indicators: {
          tabs: {
            'kpi-table-configuration': {
              title: 'Tabelas',
              header: {
                'create-btn': {
                  text: 'Nova Tabela de Indicadores',
                },
                'search-input': {
                  placeholder: 'Procurar por nome...',
                },
              },
              form: {
                'create-title': {
                  text: 'Criar Tabela de Indicadores',
                },
                'edit-title': {
                  text: 'Editar Tabela de Indicadores',
                },
                fields: {
                  name: {
                    placeholder: 'Nome',
                    'required-message': 'Nome é obrigatório',
                  },
                  indicator: {
                    placeholder: 'Indicador',
                  },
                },
                save: {
                  text: 'Salvar',
                },
                cancel: {
                  text: 'Cancelar',
                },
              },
              delete: {
                'confirmation-text': 'Confirmar Remoção?',
                text: 'Apagar',
              },
              table: {
                column: {
                  name: {
                    text: 'Indicador',
                  },
                  format: {
                    text: 'Tipo',
                  },
                  actions: {
                    text: 'Ações',
                  },
                },
              },
            },
            'kpi-configuration': {
              title: 'Indicadores',
              header: {
                'create-btn': {
                  text: 'Novo Indicador',
                },
                'search-input': {
                  placeholder: 'Procurar por nome...',
                },
              },
              form: {
                'create-title': {
                  text: 'Criar Indicador',
                },
                'edit-title': {
                  text: 'Editar Indicador',
                },
                fields: {
                  name: {
                    placeholder: 'Nome',
                    'required-message': 'Nome é obrigatório',
                  },
                  format: {
                    'required-message': 'Tipo é obrigatório',
                    placeholder: 'Tipo',
                  },
                },
                save: {
                  text: 'Salvar',
                },
                cancel: {
                  text: 'Cancelar',
                },
              },
              table: {
                column: {
                  name: {
                    text: 'Indicador',
                  },
                  format: {
                    text: 'Tipo',
                  },
                  actions: {
                    text: 'Ações',
                  },
                },
              },
            },
          },
        },
        tabs: {
          modules: {
            title: 'Módulos',
            cards: {
              accounting: {
                title: 'Contábil',
                description: 'Confira o Balanço Patrimonial, DRE e outras demonstrações contábeis da empresa',
              },
              financial: {
                title: 'Financeiro',
                description:
                  'Faça a análise de Fluxo de Caixa, DRE Gerencial, Burn Rate, Runway e outras métricas financeiras',
              },
              comertial: {
                title: 'Comercial',
                description:
                  'Confira as métricas comerciais da empresa. Pipeline completo, Taxa de conversão, Churn Rate e muito mais',
              },
              indicators: {
                title: 'Dados Complementares',
                description: 'Adicione e monitore dados complementares da sua empresa',
              },
            },
          },
          alerts: {
            title: 'Alertas',
          },
          users: {
            title: 'Usuários',
          },
        },
      },
      dataIterator: {
        rowsPerPageText: 'Element per sida:',
        pageText: '{0}-{1} de {2}',
      },
      dataFooter: {
        itemsPerPageText: 'Itens por página:',
        pageText: '{0}-{1} de {2}',
        itemsPerPageAll: 'Todas',
        nextPage: 'Próxima Página',
        prevPage: 'Página Anterior',
        lastPage: 'Última Página',
        firstPage: 'Primeira Página',
      },
    },
  },
};

// @ts-ignore
const i18n = new createI18n({
  legacy: false, // Vuetify does not support the legacy mode of vue-i18n
  locale: 'en',
  fallbackLocale: 'en',
  messages,
});
export default i18n;
